// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iKMB6","placeholdersHeader":"styles_placeholdersHeader__3H6h_","editorStyle":"styles_editorStyle__2fd3r","placeholdersBox":"styles_placeholdersBox__2Ynm-"};